export default __webpack_public_path__ + "static/media/ModalClose.cd28da0b.svg";